<template>
  <div id="service" class="service-wrap pb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style3 text-center mb-40">
            <span>What's Happening</span>
            <h2>We're Providing Best Services To Our Customers</h2>
          </div>
        </div>
      </div>

      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="service-slider-four"
      >
        <Slide v-for="service in services" :key="service.id">
          <div class="service-card style7">
            <img :src="service.image" alt="Image" />

            <div class="service-info">
              <h3>
                <router-link to="/service-details">
                  {{ service.title }}
                </router-link>
              </h3>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Pagination />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";

export default defineComponent({
  name: "BestServices",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    services: [
      {
        id: 1,
        image: require("../../assets/images/service/service-10.jpg"),
        title: "Resurfacing",
      },
      {
        id: 2,
        image: require("../../assets/images/service/service-11.jpg"),
        title: "Resurfacing",
      },
      {
        id: 3,
        image: require("../../assets/images/service/service-12.jpg"),
        title: "Resurfacing",
      },
      {
        id: 4,
        image: require("../../assets/images/service/service-13.jpg"),
        title: "Resurfacing",
      },
      {
        id: 5,
        image: require("../../assets/images/service/service-14.jpg"),
        title: "Resurfacing",
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      992: {
        itemsToShow: 3,
        snapAlign: "center",
      },
      1200: {
        itemsToShow: 4,
        snapAlign: "start",
      },
    },
  }),
});
</script>